import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TranslatorService {

  public lang = [];
  public loginService;
  constructor() { }
  public setLoginService(param) {
    this.loginService = param;
  }
  public async loadLanguage(id, code) {
    const path = '/lang/' + code;
    await this.loginService.grabdata(path).then((data: any) => {
      if (data !== 'fail') {
        if (data.data != null) {
          this.lang = data.data;
        }
      }
      else {
      }
    });
  }
  public translate(id, alt)
  {
    if(this.lang[id] === undefined)
    {
      return alt;
    }
    return this.lang[id];
  }
  public parse(text: string, params): string {
    let val: string = this.lang[text];
    for(const element of params)
    {
      val = val.replace('~', element);
    }
    return val;
  }
}
